import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

import MemLogomark from "@/assets/images/mem-logomark.svg";
import { MDSIconButton, MDSIconButtonSize, MDSIconButtonVariant, MDSIconKind } from "@/mds";
import { MDSZIndexes } from "@/mds/foundations";
import { AgentOverlayContent } from "@/pages/agent/components/agent-overlay-content";
import { useAppStore } from "@/store";

export const AgentOverlay = observer(() => {
  const { store } = useAppStore();
  const { agentOverlay } = store;

  if (!agentOverlay.isOpen) return null;

  return (
    <StyledOverlayRoot data-test-id="agent-overlay">
      <StyledHeader>
        <StyledLogo src={MemLogomark} alt="Mem" />
        <MDSIconButton
          aria-label="Close agent"
          iconKind={MDSIconKind.Exit}
          size={MDSIconButtonSize.Small}
          variant={MDSIconButtonVariant.Transparent}
          onPress={() => agentOverlay.close()}
        />
      </StyledHeader>
      <StyledBody>
        <AgentOverlayContent activeSurface={agentOverlay.activeSurface} />
      </StyledBody>
    </StyledOverlayRoot>
  );
});

const StyledOverlayRoot = styled.div`
  background: ${({ theme }) => theme.colors.surface.onboarding};
  display: flex;
  flex-direction: column;
  inset: 0;
  position: fixed;
  z-index: ${MDSZIndexes.ScreenOverlay};
`;

const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
`;

const StyledLogo = styled.img`
  display: block;
  height: 22px;
  width: 22px;
`;

const StyledBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;
